__webpack_require__.p = "/jg-spa/jg-pages-creation/";